import { MESSAGE_HIDE, MESSAGE_SHOW } from '../../nexusConstants';

const initialState = {
  state: null,
  options: {
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center',
    },
    autoHideDuration: 6000,
    message: 'Hi',
    variant: null,
  },
};

const message = (state = initialState, action) => {
  switch (action.type) {
    case MESSAGE_SHOW: {
      return {
        state: true,
        options: {
          ...initialState.options,
          ...action.options,
        },
      };
    }
    case MESSAGE_HIDE: {
      return {
        ...state,
        state: null,
      };
    }
    default: {
      return state;
    }
  }
};

export default message;
